import React from 'react';
import { MdArrowForward } from 'react-icons/md';

type FilterSeparatorProps = React.HtmlHTMLAttributes<SVGElement>;

export const FilterSeparator = ({ ...props }: FilterSeparatorProps) => <MdArrowForward color="var(--gray-400)" width={20} height={20} {...props} />;
